<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card>
    <div class="p-fluid lk-eu-mobile-form-fields">
      <div class="field">
        <label class="font-medium required-field">Клиент</label>
        <crm-client-auto-complete
          [isError]="$any(errors?.client)"
          [(selectedClient)]="task.client"
          [showClear]="true"
          [customSearch]="false"
          appendTo="body"></crm-client-auto-complete>
        <small
          *ngIf="errors?.client"
          class="p-error">
          {{ errors.client | join }}
        </small>
      </div>

      <p-messages severity="info">
        <ng-template pTemplate="">
          <div class="flex gap-2 align-items-center">
            <i
              class="pi pi-exclamation-circle"
              style="font-size: 1.3rem"></i>
            <p>Выберите сотрудников, на которых нужно оформить постоянный пропуск</p>
          </div>
        </ng-template>
      </p-messages>

      <div class="field">
        <label class="font-medium required-field">Сотрудники</label>
        <crm-external-user-multi-select
          [(selectedEntities)]="selectedEmployees"
          [clientId]="task.client?.id"
          [requireClientId]="true"
          [isError]="$any(errors?.employees)"
          appendTo="body"></crm-external-user-multi-select>
      </div>

      <div class="field">
        <label class="font-medium">Описание</label>
        <crm-editor
          [(value)]="task.description"
          height="250px"></crm-editor>
        <small
          *ngIf="errors?.description"
          class="p-error">
          {{ errors.description | join }}
        </small>
      </div>
    </div>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveTask()"></crm-button>

      <crm-button
        *ngIf="(form$ | async)?.isShowDelete && task['status'] === PassageOrderStatusEnum.NEW"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteTask($any(task))"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
